import { Item }   from './items.model';
import * as firestoreService    from  '../../../../common/firestore.service';
import { getUser } from '../../../login/login.service';

export function addItem(item: Item): Promise<any> {
    const userEmail = getUser().email;
    const id = firestoreService.getRandomIDInCollection(`Users/${userEmail}/Items`);
    item.id = id;
    return firestoreService.addSubDocument('Users', userEmail, 'Items', id, item.toJson());
}

export function getItem(id: string, next: any) {
    const userEmail = getUser().email;
    firestoreService.fetchSubDocument('Users', userEmail, 'Items', id, Item, next);
}

export function getAllItems(next: any) {
    const userEmail = getUser().email;
    return firestoreService.fetchSubCollection('Users', userEmail, 'Items', Item, next);
}

export function editItem(id: string, item: Item): Promise<any> {
    const userEmail = getUser().email;
    return firestoreService.updateSubDocument('Users', userEmail, 'Items', id, item.toJson());
}

export function deleteItem(id: string): Promise<any> {
    const userEmail = getUser().email;
    return firestoreService.deleteSubDocument('Users', userEmail, 'Items', id);
}

